import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import axios from "axios";
import AuthServices from "./services/AuthServices";
import { AdminProvider } from "./providers/AdminContext";
import { WindowContextProvider } from "./providers/WindowContext";

/* axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken"; */
axios.interceptors.request.use((config) => {
  const token = AuthServices.getToken();
  if (token) {
    config["headers"] = {
      Authorization: `Bearer ${token}`,
    };
  }
  config["validateStatus"] = (status) => true;
  return config;
});

axios.interceptors.response.use(
  async (response) => {
    if (
      response !== undefined &&
      response.status === 401 &&
      response.config &&
      !response.config.__isRetryRequest
    ) {
      if (
        window.location.pathname !== "/auth/login" &&
        window.location.pathname !== "/admin/error404"
      ) {
        sessionStorage.setItem("nextUrl", window.location.pathname);
      }
      const rs = await AuthServices.refreshToken(response.data);
      if (rs.data.access_token) {
        response.config.__isRetryRequest = true;
        response.config.headers.token = AuthServices.getToken();
        return axios(response.config);
      } else if (rs.status === 400) {
        sessionStorage.setItem("nextUrl", "");
        window.location = "/auth/login";
        return;
      }
      return rs;
    }
    if (
      response.status === 400 &&
      response.data.message === "El refresh token expiró"
    ) {
      sessionStorage.setItem("nextUrl", "");
      window.location = "/auth/login";
      return;
    }
    return response;
  },
  async function (error) {
    const access_token = AuthServices.getToken();
    if (
      error.response !== undefined &&
      error.response.status === 401 &&
      access_token
    ) {
      const response = await AuthServices.refreshToken(error);
      return response;
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AdminProvider>
    <WindowContextProvider>
      <App />
    </WindowContextProvider>
  </AdminProvider>
);
